import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from '../cart/services/store';
import PointActionsSlider from './components/point_actions_slider/PointActionsSlider';
import JoinTheLounge from './components/join_the_lounge/JoinTheLounge';
import Faqs from './components/faqs/Faqs';
import PointAction from './components/point_actions_slider/point_action/PointAction';
import RedeemPointAction from './components/point_actions_slider/redeem_point_action/RedeemPointAction';
import { loyaltyProgramActions } from './actions';

window.store = window.store || store;

document.addEventListener('DOMContentLoaded', () => {
  let element = document.getElementById('react-loyalty-program-data');
  let { pointMovements } = element.dataset;
  pointMovements = JSON.parse(pointMovements);

  window.store.dispatch(loyaltyProgramActions.setPointMovements(pointMovements));

  element = document.getElementById('react-join-the-lounge');

  createRoot(
    element,
  ).render(
    <Provider store={window.store}>
      <JoinTheLounge />
    </Provider>,
  );

  element = document.getElementById('react-get-involved');
  if (element) {
    let { pointActions } = element.dataset;
    pointActions = JSON.parse(pointActions);

    createRoot(
      element,
    ).render(
      <Provider store={window.store}>
        <PointActionsSlider pointActions={pointActions} pointActionWrapper={PointAction} />
      </Provider>,
    );
  }

  element = document.getElementById('react-redeem');

  if (element) {
    let { redeemPointActions } = element.dataset;
    redeemPointActions = JSON.parse(redeemPointActions);

    createRoot(
      element,
    ).render(
      <Provider store={window.store}>
        <PointActionsSlider
          pointActions={redeemPointActions}
          pointActionWrapper={RedeemPointAction}
        />
      </Provider>,
    );
  }

  element = document.getElementById('faqs');

  if (element) {
    let { faqs } = element.dataset;
    faqs = JSON.parse(faqs);
    createRoot(
      element,
    ).render(
      <Faqs faqs={faqs} />,
    );
  }

  const StickyCategories = React.lazy(() => import('../homepage/components/sticky_categories/StickyCategories'));
  createRoot(
    document.getElementById('react-sticky-categories'),
  ).render(
    <Suspense fallback="">
      <Provider store={window.store}>
        <StickyCategories />
      </Provider>
    </Suspense>,
  );
});
